import { clientRepo } from "~/server/apis/client_repo";
import { BrandExtraMetadata, VoucherProduct } from "~/server/types/brand";

export type BrandL2TelescopeRouteData = {
  brand: VoucherProduct;
  brandExtraMetadata: BrandExtraMetadata;
};

export const getBrandL2TelescopeRouteData = async (
  brandKey: string
): Promise<BrandL2TelescopeRouteData> => {
  const [brand, brandExtraMetadata] = await Promise.all([
    clientRepo.getBrand(brandKey),
    clientRepo.getBrandExtraMetadata(brandKey),
  ]);

  return {
    brand,
    brandExtraMetadata,
  };
};
